const links = document.querySelectorAll(".js-link");
links.forEach(link => {
  link.addEventListener('click', scrollIt);
});

function scrollIt(e) {
  e.preventDefault();
  let linkHref = this.getAttribute('href');
  let linkTarget = document.querySelector(linkHref);

  window.scroll({
    behavior: "smooth",
    left: 0,
    top: linkTarget.offsetTop + 100,
  });
}
